export enum GameLevel {
  EASY, MEDIUM, DIFFICULT
}
